<template>
  <div id="grafico-no-moving-v2" style="width: 100%; height: calc(100vh - 390px);"></div>
</template>

<script setup>
import * as echarts from 'echarts';
import {computed, nextTick, onMounted, watch} from "vue";
import {useHelpers} from "@/components/indicadores/NoMovingV2/helpers";
import formatadorValor from "@/helpers/formatarValoresBi"
import {formatarValorComCasas} from "@/helpers";

const {niveis_servicos, histogramas} = useHelpers();

const props = defineProps({
  dados_analise: Object,
});

const PRIMEIRA_CHAVE_OBJ_COMPUTED = computed(() => {
  const chaves = Object.keys(props.dados_analise);
  return chaves[0] || null;
});

const app = {};

let grafico;

onMounted(async () => {
  const chartDom = document.getElementById('grafico-no-moving-v2');

  grafico = echarts.init(chartDom);
  grafico.setOption(OPCOES_GRAFICO_COMPUTED.value);

  await nextTick();
  grafico.resize();

  window.addEventListener('resize', () => grafico.resize());
});

watch(() => props.dados_analise, () => {
  grafico.setOption(OPCOES_GRAFICO_COMPUTED.value);
  grafico.resize();
});

app.configParameters = {
  rotate: {
    min: -90,
    max: 90
  },
  align: {
    options: {
      left: 'left',
      center: 'center',
      right: 'right'
    }
  },
  verticalAlign: {
    options: {
      top: 'top',
      middle: 'middle',
      bottom: 'bottom'
    }
  },
  distance: {
    min: 0,
    max: 100
  }
};

app.config = {
  rotate: 78,
  align: 'left',
  verticalAlign: 'middle',
  position: 'insideTop',
  distance: -5,
};

const labelOption = {
  show: true,
  position: app.config.position,
  distance: app.config.distance,
  align: app.config.align,
  verticalAlign: app.config.verticalAlign,
  rotate: app.config.rotate,
  formatter: (item) => Number(item.value) > 0 ? formatadorValor(Number(item.value)) : '',
  fontSize: 11,
  color: 'black',
  rich: {
    name: {}
  }
};

const SERIES_COMPUTED = computed(() => {
  return [
    ...Object.keys(props.dados_analise[PRIMEIRA_CHAVE_OBJ_COMPUTED.value]).map(nivel_servico => ({
      name: nivel_servico,
      type: 'bar',
      barGap: 0.1,
      label: labelOption,
      emphasis: {
        focus: 'series'
      },
      data: histogramas.map(histograma => Number(props.dados_analise[histograma][nivel_servico]))
    }))
  ];
});

const OPCOES_GRAFICO_COMPUTED = computed(() => ({
  grid: {
    left: '0%',
    right: '0%',
    bottom: '0%',
    containLabel: true,
    shadowOffsetX: {
      show: true,
    }
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        formatter: label => {
          if (label.axisDimension === 'y') {
            return `R$ ${formatarValorComCasas(Number(label.value), 2)}`;
          }

          return label.value;
        }
      }
    },
    valueFormatter: valor => `R$ ${formatarValorComCasas(valor, 2)}`
  },
  legend: {
    data: niveis_servicos,
    padding: 20
  },
  toolbox: {
    show: false
  },
  xAxis: [
    {
      type: 'category',
      axisLabel: {
        fontSize: 11,
        color: 'black',
        interval: 0,
        formatter: function (value) {
          return value.substring(3);
        }
      },
      splitLine: {
        show: true
      },
      data: Object.keys(props.dados_analise),
    },
  ],
  yAxis: [
    {
      type: 'value',
      splitLine: {
        show: true
      },
      axisLabel: {
        formatter: valor => `R$ ${formatarValorComCasas(valor, 0)}`
      }
    }
  ],
  color: ['#FD0001', '#FFBF05', '#FFFE02', '#00AE51', '#0071C1', '#0D0D0D'],
  series: SERIES_COMPUTED.value,
}));
</script>
